import { HomeIcon } from "@heroicons/react/24/solid";

export const HomeHeader = () => {
    return (
        <div className="pb-2 mb-4 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <HomeIcon className="h-6 w-6 text-gray-800" />
            <h1 className="text-2xl font-bold text-gray-800">Inicio</h1>
          </div>
          <div className="flex items-center space-x-4">
            <div className="text-sm text-gray-500">¡Bienvenido!</div>
          </div>
        </div>
      </div>
    );
};